"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Breakpoints
 */
var breakpoints = exports.breakpoints = {
  xxs: 320,
  xs: 360,
  s: 520,
  m: 720,
  l: 900,
  xl: 1060,
  xxl: 1200,
  xxxl: 1400,
  huge: 1600,
  full: 1920,
  fullXl: 2080,
  fullXxl: 2240,
  fullXxxl: 2400
};

/**
 * Max-width
 * @param  {Number} x
 * @return {String}
 *
 * e.g ->
 * [maxWidth(700)]: {
 *   paddingLeft: '0.2em',
 * }
 */
var maxWidth = exports.maxWidth = function maxWidth(x) {
  return "@media (max-width: " + (x - 1) + "px)";
};

/**
 * Min-width
 * @param  {Number} x
 * @return {String}
 *
 * e.g ->
 * [minWidth(700)]: {
 *   position: 'relative',
 *   textAlign: 'right',
 * }
 */
var minWidth = exports.minWidth = function minWidth(x) {
  return "@media (min-width: " + x + "px)";
};

/**
 * Between-width
 * @param  {Number} x
 * @param  {Number} y
 * @return {String}
 *
 * e.g ->
 * [betweenWidth(1200, 1600)]: {
 *   display: 'block',
 * }
 */
var betweenWidth = exports.betweenWidth = function betweenWidth(x, y) {
  return "@media (min-width: " + x + "px) and (max-width: " + (y - 1) + "px)";
};